// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__TZU7u","fade-in":"Modal_fade-in__jcB-k","close":"Modal_close__ydciZ","fade-out":"Modal_fade-out__kZ4-B"};